import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Col, Form } from "react-bootstrap";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";

import {
  translationConstants,
  viewPathConstants,
  spotConstants,
  GoogleMapConstants,
} from "../../../../../constants";
import GoogleMapView from "../../../../../shared/components/GoogleMap/GoogleMapView";
import { centerListingActions, authActions, centersActions } from "../../../../../redux/actions";
import ViewCenterCard from "../../../../../shared/components/ViewCenterCard/ViewCenterCard";
import General from "../../../../../modules/GuestUser/Views/Centers/CenterProfile/CenterProfieTabs/GeneralTab/General";
import { loadingIndicator, dataEndMessage } from "../../../../../shared/utilitiies"

//-------default query expression
const defaultQueryExpression = "id != null ";
//-------initial gridstate
const initialGridState = {
  length: 7,
  search: null,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: defaultQueryExpression,
};

const SpotCenters = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //-------reducers
  const centerListingReducer = useSelector(
    (state) => state.centerListingReducer
  );
  //-------destructure reducers
  const { centerSpotListingData } = centerListingReducer;

  //-------Center Listing
  const { pageData } = centerSpotListingData;

  const { centerProfileData } = centerListingReducer;

  //-------UseState
  const [hasMore, setHasMore] = useState(true);
  const [centersArray, setCentersArray] = useState([]);
  const [gridState, setGridState] = useState(initialGridState);
  const [centersSpots, setCentersSpots] = useState([]);
  const [mapCenter, setMapCenter] = useState({
    lat: GoogleMapConstants.DEFAULT_LATITUDE,
    lng: GoogleMapConstants.DEFAULT_LONGITUDE,
  });
  const [isViewDetail, setIsViewDetail] = useState(null);


  //-------Map Style
  const MapContainerStyle = {
    width: "100%",
    height: "35vh",
    borderRadius: ".5em",
  };

  //-------Map options
  const options = {
    zoomControl: true,
    clickableIcons: false,
    disableDefaultUI: true,
  };

  //-------handle click on center card view details
  const handleViewDetails = (centerId) => {
    getCenterProfileById(centerId);
    getCenterLogoById(centerId);
    setIsViewDetail(true);
  };
  //-------Get center profile by center id
  const getCenterProfileById = (id) => {
    dispatch(centerListingActions.getViewCenterProfileById(id));
  };

  //-------Get center Logo by center id
  const getCenterLogoById = (id) => {
    dispatch(centersActions.getCenterLogo(id));
  };
  //-------Get More Centers List on Scroll
  const getMoreCenterDetails = () => {
    const updatedGridState = { ...gridState, length: gridState.length + 7 };
    setGridState(updatedGridState);
  };

  //-------UseEffects
  useEffect(() => {
    dispatch(centerListingActions.getAllApprovedCentersListBySpotId(gridState, props.spotId));
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    setCentersArray(pageData);
    const spotObj = {
      latitude: parseFloat(props.spotDetail?.spotInfo?.lat),
      longitude: parseFloat(props.spotDetail?.spotInfo?.long),
      locationName: props.spotDetail?.spotInfo.name,
      locationArabicName: props.spotDetail?.spotInfo.arabicName,
      spotTypeId: props.spotDetail?.spotInfo.spotTypeId,
      sports: props.spotDetail?.sportIds,
      isPublic: props.spotDetail?.spotInfo.spotTypeId,
    };
    setCentersSpots([spotObj]);
    // eslint-disable-next-line
  }, [pageData]);

  useEffect(() => {
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
    // eslint-disable-next-line
  }, []);
  //-------return view centers component
  return (
    isViewDetail ? (
      <General centerProfileData={centerProfileData} isShowCenter={true}/>
    ) : (
      <div className="row m-0 py-2">
        <div className="col-12 mt-3 p-0">
          <GoogleMapView
            containerStyle={MapContainerStyle}
            options={options}
            mapCenter={mapCenter}
            locations={centersSpots}
          />
        </div>
        <div className="col-12 mt-3 px-0">
          <InfiniteScroll
            dataLength={centersArray?.length ?? 0}
            next={getMoreCenterDetails}
            hasMore={
              centersArray?.length % 7 === 0 && centersArray?.length !== 0
                ? true
                : false
            }
            loader={loadingIndicator(t)}
            endMessage={dataEndMessage(t, centersArray)}
            style={{ overflow: "hidden" }}
            scrollableTarget={"main-container"}
          >
            <div className="row">
              {centersArray?.map((center) => {
                return (
                  <ViewCenterCard
                    center={center}
                    handleViewDetails={handleViewDetails}
                  />
                );
              })}
            </div>
          </InfiniteScroll>
        </div>
      </div>)
  );
};

export default SpotCenters;
